export class PressKeysAction {
    constructor(string, virtualKeyCodes) {
        this.name = 'PressKeys';
        this.isDeviceAction = false;
        this.data = { string, virtualKeyCodes };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJlc3NLZXlzQWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9tb2RlbHMvYWN0aW9ucy9QcmVzc0tleXNBY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0EsTUFBTSxPQUFPLGVBQWU7SUFRMUIsWUFBWSxNQUFjLEVBQUUsZUFBd0I7UUFQcEMsU0FBSSxHQUFHLFdBQVcsQ0FBQztRQUNuQixtQkFBYyxHQUFHLEtBQUssQ0FBQztRQU9yQyxJQUFJLENBQUMsSUFBSSxHQUFHLEVBQUUsTUFBTSxFQUFFLGVBQWUsRUFBRSxDQUFDO0lBQzFDLENBQUM7Q0FDRiJ9